










































































import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { ITemplateContent, ITemplateCategory } from "@/models/templates";
import { ILanguage } from "@/models/constants";
import HasValidation from "@/mixins/HasValidation";
import { DataModules } from "@/store/modules/data";
import {
  ITemplateProvider,
  ITemplateProviderMethods
} from "@/models/providers/templates";

type Form = Partial<ITemplateContent>;

const initialForm = (): Form => {
  return {
    id: undefined,
    subject: "",
    body: "",
    enabled: true,
    language_id: undefined
  };
};

@Component({
  components: {
    "notification-content": () =>
      import("@/components/app/global/templates/contentForm.vue")
  }
})
export default class TranslationContentsForm extends Mixins(
  RequestPromises,
  HasValidation
) {
  // Inject

  @Inject({ from: "templateProvider" })
  public templateProvider!: () => ITemplateProvider;

  @Inject({ from: "templateProviderMethods" })
  public $templateMethods!: ITemplateProviderMethods;

  // Props

  @Prop({ required: false, default: "" })
  public contentId!: string;

  @Prop({ required: true })
  public languages!: ILanguage[];

  @Prop({ required: true })
  public languageId!: ILanguage["id"];

  @Prop({ required: true })
  public categories!: ITemplateCategory[];

  @Prop({ default: true })
  public showSubject!: boolean;

  public processing = false;
  public isLoading = true;
  public isReloading = false;
  public requestError = false;
  public form: Form = initialForm();
  public initialForm: Form = initialForm();
  public templateContent!: ITemplateContent;

  public async created() {
    await this.loadData();
  }

  public get $templateData() {
    return this.templateProvider();
  }

  public get template() {
    return this.$templateData.template;
  }

  public get exists() {
    return this.contentId.toString().length > 0;
  }

  public async loadData() {
    try {
      await this.getNotificationTemplateContent();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    }
    this.isLoading = false;
    this.isReloading = false;
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public async getNotificationTemplateContent() {
    if (!this.exists) {
      this.form.language_id = this.languageId;
      return Promise.resolve();
    }

    this.templateContent = await this.$store.dispatch(
      `data/${DataModules.TEMPLATES_CONTENTS}/get`,
      {
        id: this.contentId,
        templateId: this.template.id,
        storeData: false
      }
    );

    this.form = this.$_.pick(
      this.templateContent,
      this.$_.concat(
        ["id", "language_id", "enabled", "body"],
        this.showSubject ? ["subject"] : []
      )
    ) as Form;

    this.$set(this, "initialForm", this.$_.clone(this.form));
  }

  public get isFormChanged(): boolean {
    return !this.$_.isEqual(this.form, this.initialForm);
  }

  public validateBeforeSubmit() {
    if (!this.canSave) {
      return;
    }
    this.processing = true;
    this.validate()
      .then(result => {
        if (result) {
          return this.exists
            ? this.$templateMethods.updateContents(
                this.templateContent?.id,
                this.form
              )
            : this.$templateMethods.createContents(this.form);
        }
        throw this.$t("_sentence.form_is_not_valid");
      })
      .then((templateContent: ITemplateContent) => {
        this.$buefy.toast.open({
          message: this.$t("_sentence.successfully_saved") as string
        });
        this.$emit("contents-updated", { templateContent });
        this.$emit("close");
      })
      .catch(error => {
        this.$store.dispatch("api/handleValidationError", {
          error,
          vm: this
        });
      })
      .finally(() => (this.processing = false));
  }

  public get canSave() {
    return this.exists
      ? this.$userCan("update_template_content")
      : this.$userCan("create_template_content");
  }
}
